import { render, staticRenderFns } from "./elec.vue?vue&type=template&id=5b5def01&scoped=true&"
import script from "./elec.vue?vue&type=script&lang=js&"
export * from "./elec.vue?vue&type=script&lang=js&"
import style0 from "./elec.vue?vue&type=style&index=0&id=5b5def01&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5def01",
  null
  
)

export default component.exports